import React, { useRef, useState, useEffect } from 'react';
import { useAvatar } from '../hooks/useAvatar';

export default function AvatarUpload({ userId, nome, size = 72, onUpload }) {
  const inputRef = useRef(null);
  const { uploadAvatar, uploading } = useAvatar();
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    if (!userId) return;
    // Tentar carregar avatar existente
    const url = `${process.env.REACT_APP_SUPABASE_URL}/storage/v1/object/public/avatars/${userId}/avatar.jpg`;
    const img = new Image();
    img.onload = () => setAvatarUrl(url);
    img.onerror = () => {
      const urlPng = url.replace('.jpg', '.png');
      const img2 = new Image();
      img2.onload = () => setAvatarUrl(urlPng);
      img2.onerror = () => setAvatarUrl(null);
      img2.src = urlPng;
    };
    img.src = url;
  }, [userId]);

  async function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    const url = await uploadAvatar(userId, file);
    setAvatarUrl(url);
    if (onUpload) onUpload(url);
    e.target.value = '';
  }

  const inicial = (nome || '?').charAt(0).toUpperCase();

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <div
        onClick={() => inputRef.current?.click()}
        style={{
          width: size, height: size, borderRadius: '50%',
          background: avatarUrl ? 'transparent' : 'var(--text)',
          border: '2px solid var(--accent)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          cursor: 'pointer', overflow: 'hidden', position: 'relative',
          transition: 'opacity 0.2s',
        }}
        title="Clique para trocar a foto"
      >
        {avatarUrl ? (
          <img src={avatarUrl} alt={nome} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
        ) : (
          <span style={{ fontFamily: "'Inter', sans-serif", fontSize: size * 0.4, fontWeight: 700, color: '#FAF7F2' }}>{inicial}</span>
        )}
        {/* Overlay ao hover */}
        <div style={{
          position: 'absolute', inset: 0, background: 'rgba(37,28,25,0.45)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          opacity: 0, transition: 'opacity 0.2s',
        }} className="avatar-overlay">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.5" strokeLinecap="round">
            <path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"/>
            <circle cx="12" cy="13" r="4"/>
          </svg>
        </div>
      </div>

      {uploading && (
        <div style={{ position: 'absolute', inset: 0, borderRadius: '50%', background: 'rgba(37,28,25,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div style={{ width: 16, height: 16, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
        </div>
      )}

      <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} style={{ display: 'none' }} />

      <style>{`
        .avatar-overlay { opacity: 0 !important; }
        div:hover > .avatar-overlay { opacity: 1 !important; }
        @keyframes spin { to { transform: rotate(360deg); } }
      `}</style>
    </div>
  );
}
